import { render } from "./JobDescriptionView.vue?vue&type=template&id=11ae2bca"
import script from "./JobDescriptionView.vue?vue&type=script&lang=js"
export * from "./JobDescriptionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__